"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBuiltinName = exports.BuiltinName = void 0;
var BuiltinName;
(function (BuiltinName) {
    BuiltinName["Add"] = "+";
    BuiltinName["Subtract"] = "-";
    BuiltinName["Multiply"] = "*";
    BuiltinName["Divide"] = "/";
    BuiltinName["Modulus"] = "%";
    BuiltinName["GreaterThan"] = ">";
    BuiltinName["GreaterEqualThan"] = ">=";
    BuiltinName["LessThan"] = "<";
    BuiltinName["LessEqualThan"] = "<=";
    BuiltinName["Equal"] = "==";
    BuiltinName["NotEqual"] = "!=";
    BuiltinName["And"] = "&&";
    BuiltinName["Or"] = "||";
    BuiltinName["Not"] = "!";
    BuiltinName["Tuple2"] = ",";
    BuiltinName["Tuple3"] = ",,";
    BuiltinName["Tuple4"] = ",,,";
    BuiltinName["Tuple5"] = ",,,,";
    BuiltinName["Compose"] = ".";
    BuiltinName["Pipe"] = "|>";
    BuiltinName["Constant"] = "const";
    BuiltinName["Identity"] = "id";
    BuiltinName["EqualPolymorphic"] = "eq";
    BuiltinName["ToString"] = "toString";
    BuiltinName["SquareRoot"] = "sqrt";
    BuiltinName["Floor"] = "floor";
    BuiltinName["Ceil"] = "ceil";
    BuiltinName["First"] = "first";
    BuiltinName["Second"] = "second";
    BuiltinName["ExtendArray"] = "extend";
    BuiltinName["Head"] = "head";
    BuiltinName["Tail"] = "tail";
    BuiltinName["IsEmpty"] = "isEmpty";
    BuiltinName["Concat"] = "++";
    BuiltinName["Map"] = "map";
    BuiltinName["Filter"] = "filter";
    BuiltinName["Reduce"] = "reduce";
    BuiltinName["Reduce0"] = "reduce0";
    BuiltinName["Join"] = "join";
    BuiltinName["Length"] = "length";
    BuiltinName["ToLower"] = "lower";
    BuiltinName["ToUpper"] = "upper";
})(BuiltinName = exports.BuiltinName || (exports.BuiltinName = {}));
function isBuiltinName(name) {
    return Object.values(BuiltinName).includes(name);
}
exports.isBuiltinName = isBuiltinName;
//# sourceMappingURL=builtins.js.map